"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const Badge_1 = __importDefault(require("components/shared/Badge"));
const TabsContext = (0, react_1.createContext)(null);
const Tabs = ({ children, type = 'large', currentTab }) => {
    const [moreThanOneContent, setMoreThanOneContent] = (0, react_1.useState)(false);
    return (react_1.default.createElement(TabsContext.Provider, { value: {
            type,
            currentTab,
            moreThanOneContent,
            setMoreThanOneContent
        } }, children));
};
const useTabs = () => {
    return (0, react_1.useContext)(TabsContext);
};
const Button = ({ children, badge, id, dataCy = '', role = '', dataTitle = '', onClick, withCount, withBadge }) => {
    const { type, currentTab } = useTabs() || {};
    const isActive = currentTab === id;
    const buttonCN = (0, classnames_template_literals_1.default)(`
    animate-fadein
    transition-all
    duration-100
    group
    flex
    item-center
    mr-[8px]
    cursor-pointer
    px-[8px]
    hover:bg-base-30024 rounded-t-md
    active:bg-base-30016
    ${type == 'small' ? 'h-[32px]' : 'h-[40px]'}
  `);
    const buttonChildCN = (0, classnames_template_literals_1.default)(`
    animate-fadein
    transition-all
    duration-100
    flex
    whitespace-nowrap
    items-start
    items-center
    border-solid
    border-0
    pt-[8px]
    ${type == 'small'
        ? 'typography-button pb-[6px]'
        : 'typography-h500 pb-[10px]'}
    ${isActive && 'border-b-2 border-base-600 active'}
    ${isActive && type == 'small'
        ? 'text-base-600'
        : isActive
            ? 'text-n-900'
            : 'text-n-600'}
  `);
    return (react_1.default.createElement("li", { className: buttonCN, onClick: () => onClick && onClick(), "data-cy": dataCy, role: role, "data-title": dataTitle },
        react_1.default.createElement("span", { className: buttonChildCN },
            children,
            withCount &&
                (withBadge ? (badge && badge > 0 ? (react_1.default.createElement(Badge_1.default, { bgColorHex: (0, HelperUtils_1.getCssVariableValue)('--r-600'), colorHex: (0, HelperUtils_1.getCssVariableValue)('--n-000'), className: "ml-[4px]" }, badge)) : ('')) : (react_1.default.createElement("span", { className: `${type == 'small' ? 'typography-button' : 'typography-h500'}
              ${isActive
                        ? type == 'small'
                            ? 'text-base-400'
                            : 'text-n-600'
                        : type == 'small'
                            ? 'text-n-400'
                            : 'text-n-600'}
              } ml-[4px]` }, `(${badge ? badge : 0})`))))));
};
const Buttons = ({ children, options, customComponent, fullWidth, customClass, childrenRef }) => {
    // if fullwidth set to w-full -> the border of tabs will fulfill the container
    // if fullwidth set to w-min -> the border of tabs will adjust to the amount of content
    const buttonsCN = (0, classnames_template_literals_1.default)(`
    ${fullWidth ? 'w-full' : 'w-min'}
    flex
    flex-row
    items-center
    list-none
    border-solid
    border-0
    border-b
    border-n-400
    -mb-[1px]
    ${customClass && customClass}
  `);
    return (react_1.default.createElement("ul", { className: buttonsCN, ref: childrenRef }, options && options?.length > 0
        ? options?.map((option, index) => {
            // check if buttons want to render a custom component
            return customComponent ? (react_1.default.createElement("li", { className: "whitespace-nowrap" }, option.content)) : (react_1.default.createElement(Button, { badge: option.badge, key: index, id: option.id, onClick: () => option?.onClick && option?.onClick() }, option.content));
        })
        : children));
};
const Contents = ({ children, options, customWrapperClass }) => {
    const { setMoreThanOneContent } = useTabs() || {};
    // store children into an array
    const child = react_1.Children.toArray(children);
    // check if content has more than one content or not
    if (child.length > 1 || (options && options?.length > 1)) {
        setMoreThanOneContent && setMoreThanOneContent(true);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, options && options?.length > 0 ? (options.map((option, index) => (react_1.default.createElement(Content, { id: option.id, key: index }, option.content)))) : (react_1.default.createElement("div", { className: customWrapperClass ? customWrapperClass : '' }, children))));
};
const Content = ({ children, id }) => {
    const { currentTab, moreThanOneContent } = useTabs() || {};
    // if there is only one content then -> always show content
    const isActive = currentTab === id || !moreThanOneContent;
    // show active content if current is tab equal with id
    return react_1.default.createElement(react_1.default.Fragment, null, isActive && children);
};
Tabs.Button = Button;
Tabs.Buttons = Buttons;
Tabs.Contents = Contents;
Tabs.Content = Content;
exports.default = Tabs;
